export const messages = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      works: 'Works',
      services: 'Services',
      insights: 'Insights',
      contact: 'Contact',
      toggle: 'Toggle menu',
    },
    hero: {
      body: 'SK Design builds brand identities, websites, motion and 3D for businesses that need to get noticed. A studio you hire — with packages, a process, and a call to start.',
      viewWork: 'View work',
      bookCall: 'Book a call',
      roleFreelance: 'Freelance',
      roleCreative: 'Creative',
      roleDesigner: 'Designer',
      disciplines: 'Brand · Web · Motion · 3D',
      openForProjects: 'Open for projects',
      linkedinAria: 'LinkedIn profile of Sander Kuyken',
      artstationAria: 'ArtStation profile of Sander Kuyken',
      mascotAlt: 'Cartoon illustration of a cheerful lemonade-glass character',
    },
    home: {
      metaTitle: 'SK Design — Brand · Web · Motion · 3D',
      metaDescription:
        'SK Design — brand identity, websites, motion and 3D for businesses. Belgian studio. Packages, a fixed quote, and a project you can start.',
      selected: 'SELECTED',
      works: 'WORKS',
      selectedBody:
        'Recent client launches and personal experiments that prove you can trust a young studio to land bold ideas, move fast, and still sweat every micro-interaction.',
      latestWork: 'LATEST WORK',
      viewAll: 'View all work',
      archiveBlurb: 'This is just the latest. The full archive spans design, motion, 3D and branding.',
      viewThisWork: 'View This Work',
      aboutEyebrow: 'A Belgian studio for brand, web, motion and 3D — pairing creative direction with technical craft.',
      aboutLine1: 'ABOUT',
      aboutLine2: 'ME',
      aboutHeading: 'Every brief is a chance to prove what a next-gen studio can do.',
      aboutBody:
        "I'm Sander — branding, motion, 3D/VFX and web/UX. The full story — how I work, education and tools — lives on the about page.",
      moreAbout: 'More about me',
      servicesHeading: 'SERVICES',
      servicesBody:
        'Strategy, UI, motion and brand systems for ambitious products — with clear packages and a fixed plan before we start.',
      seeBreakdown: 'See full breakdown & pricing',
      discussThis: 'Discuss this',
      showPrice: 'Show starting price',
      hidePrice: 'Hide price',
      processEyebrow: 'How we work',
      processTitle: 'The process',
      processIntro:
        "A calm, transparent path from first call to launch. Same backbone whether it's a logo, a brand system, a motion piece or a full custom site.",
      process1Title: 'Discover',
      process1Body:
        'A short discovery call to map goals, scope and budget. I leave with a clear brief and you leave with a fixed plan — no vague promises.',
      process2Title: 'Design & build',
      process2Body:
        'Direction in Figma, then into build. Wireframes, look-dev and motion come together so you see the thing taking shape, not just slideware.',
      process3Title: 'Refine',
      process3Body:
        'Structured revision rounds where we sweat the details — spacing, timing, copy and performance — until every frame feels intentional.',
      process4Title: 'Launch',
      process4Body:
        'Ship it properly: exports, handover, on-page SEO and post-launch support so the work keeps performing long after delivery.',
      testimonialsBody:
        'Clients talk about a partner who brings sharp ideas, transparent collaboration, and work that over-delivers without the bloated agency playbook.',
      ready: 'ready to work?',
      footerCta: "Got some exciting ideas? Let's connect and create something extraordinary together!",
      cookiePrefs: 'Cookie preferences',
      terms: 'Terms',
      viewProject: 'View the project',
    },
    servicesPage: {
      metaTitle: 'Services & Pricing',
      metaDescription:
        'Web design, motion design, branding and logo design — tiered packages with transparent pricing. Belgian studio for brand, web, motion and 3D.',
      heading: 'SERVICES',
      intro: "A clear breakdown of every service — what's in each package, what it costs, and how long it takes.",
      vat: 'All prices excl. 21% VAT.',
      faqJump: 'Got questions? Jump to FAQ',
      requestQuote: 'Request a quote',
      seePackages: 'See packages',
      bestIf: 'Best if',
      process: 'Process',
      addons: 'Available add-ons',
      mixMatch: 'Mix & match per package',
      retainerEyebrow: 'Ongoing partnership',
      retainerTitle: 'Need a designer on call, not just a one-off?',
      retainerBody:
        'A monthly retainer keeps your site, brand and content moving — updates, new pages, social motion and tweaks, all under one predictable rate.',
      discussRetainer: 'Discuss a retainer',
      customQuote: 'Get a custom quote',
      dontSee: "Don't see your scope here?",
      customBody:
        'Bigger, weirder, or somewhere in between — happy to scope a custom proposal that fits your timeline and budget.',
      laneHeading: 'Solutions that fit the brief — choose your lane',
      builtWith: 'Built with',
      serviceCount: 'Service {n} / {total}',
    },
    contactPage: {
      metaTitle: 'Contact',
      metaDescription: 'Got an idea or project? Get in touch with SK Design to discuss goals, scope and next steps.',
      heading: 'CONTACT',
      intro:
        "Let's start with a quick hello to talk through your project — goals, scope, timeline. I'll answer anything about my process, and we'll map out the next steps.",
      emailTab: 'Email me back',
      callTab: 'Book a call',
      introLong:
        "Let's start with a quick hello to talk through your project — goals, scope, timeline. I'll answer anything about my process, and we'll map out the next steps. Looking forward to connecting!",
      pickHow: 'Pick how I should get back to you — a written reply by email, or a quick discovery call. Required before sending.',
      emailReply: "I'll reply by email within 24 working hours.",
      emailBody: "Just fill in the form above — package, scope, deadline. You'll get a tailored quote and next steps in your inbox.",
      noCall: 'No call required',
      preferCall: 'Prefer to talk it through? Book a call instead →',
      nextHeading: 'What happens next',
      next1Title: 'Reply',
      next1Body: 'A personal email back within 24 working hours.',
      next2Title: 'Scope',
      next2Body: 'We align on goals, deliverables and timeline.',
      next3Title: 'Proposal',
      next3Body: 'A fixed, tailored quote — no surprises.',
      next4Title: 'Kickoff',
      next4Body: 'Deposit, shared board, and we start building.',
      howBack: 'How should I get back to you?',
      belgiumTz: 'Belgium · CET/CEST',
      discoveryCall: '30-min discovery call',
      pickSlot: 'Pick a slot that works for you — confirmation lands in your inbox right after.',
      pickPackage: 'Pick a package',
      packageSuffix: 'package',
      optional: '(optional)',
      optionalShort: 'optional',
      vatExcl: 'all prices excl. 21% VAT',
      selectedTap: 'Selected · tap to remove',
      skipPackage:
        "Not sure yet? Skip this — combine packages from multiple services or just describe your project in the message field, and I'll come back with a tailored proposal.",
      wizard: 'Guided Inquiry Wizard',
      stepOf: 'Step {n} of 3',
      stepYou: '1. You',
      stepProject: '2. Project',
      stepSend: '3. Details & Send',
      errFillValid: 'Please fill in your first name, last name, and a valid email address first.',
      errFillContinue: 'Please fill in your first name, last name, and email address to continue.',
      errEmail: 'Please enter a valid email address.',
      errPickScope: 'Pick at least one service, package or budget so I can scope your quote.',
      successTitle: 'Message received',
      successBodyBefore: "I'll get back to you within 24 working hours with a",
      successQuote: 'definitive, scoped quote',
      successBodyAfter: 'based on your request. A confirmation email with a summary is on its way to your inbox.',
      estimatorPrompt: 'Want to calculate an estimated project timeline & scope first?',
      estimatorCta: 'Scope Estimator Tool',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'E-mail',
      company: 'Company / Brand',
      firstNamePlaceholder: 'John',
      lastNamePlaceholder: 'Doe',
      emailPlaceholder: 'e-mail address',
      companyPlaceholder: 'Acme Studio',
      howFound: 'How did you find me?',
      selectOption: 'Select an option…',
      continueScope: 'Continue to Project Scope',
      servicesScope: 'Services & Scope',
      servicesHint: 'Select the services you need. You can pick multiple services or packages.',
      combineHint:
        "Combining services? Pick one package per service above and I'll add the prices together below. Prefer a fully custom scope? Just describe it in the next step.",
      addons: 'Add-ons',
      addonsHint: 'Optional extras layered on top of your package — adjust the final quote. Toggle anything that fits.',
      addonsFor: '{name} add-ons',
      budget: 'Estimated Budget',
      backDetails: 'Back to Your Details',
      continueSend: 'Continue to Message & Send',
      message: 'Message',
      messageHint: 'Tell me a bit about your project goals, timeline, or any specific details.',
      messagePlaceholder: 'Tell me about your project...',
      selectedPackages: 'Selected packages',
      quoteSummary: 'Quote summary',
      removePackage: 'Remove {name} package',
      roughTotal: 'Rough total estimate',
      plusOnQuote: '+ items on quote',
      finalQuoteNote: 'Final quote follows by email within 24 working hours · all prices excl. 21% VAT',
      termsAgreeBefore: 'I agree to the',
      termsLink: 'terms & support conditions',
      termsAgreeAfter: '— covering pricing, payment, support window, revisions, ownership and cancellation.',
      backScope: 'Back to Project Scope',
      submit: 'Submit',
      sending: 'Sending...',
      needMessage: 'Please add your message',
      needMode: 'Pick how I should get back to you',
      needTerms: 'Accept the terms to submit',
      sendError: 'Something went wrong while sending. Please try again or email info@skdesign.be directly.',
      svcWeb: 'Web design',
      svcMotion: 'Motion design',
      svcBranding: 'Branding',
      svcLogo: 'Logo design',
      svcRetainer: 'Retainer',
      svcOther: 'Other',
      refLinkedIn: 'LinkedIn',
      refArtStation: 'ArtStation',
      refInstagram: 'Instagram',
      refReferral: 'Referral',
      refSearch: 'Search',
      refOther: 'Other',
    },
    faq: {
      heading: 'WORKING TOGETHER',
      intro:
        "Honest answers to the questions every client asks before we start. Timelines, pricing, post-launch support — all the things I'd want to know.",
      still: 'Still have a question?',
      stillBody: 'Drop me a line — I usually reply within a day.',
      ask: 'Ask me anything',
      eyebrow: 'Frequently asked',
      q1: 'How long does a project take?',
      a1: 'Timelines depend on the discipline. Web design: 1–2 weeks for a Starter, 3–5 for a Standard build, 6–10+ for a Premium 3D site. Motion design (which includes 3D / VFX): 1–2 weeks for a logo animation, 3–5 for a campaign piece, 6–10+ for a full 3D scene. Branding: 2–3 weeks for a Mini set, up to 7–10+ for a Comprehensive system. Logo design: 1 week for a Logo only, up to 3 for a full Logo system. Exact dates are locked in before we start.',
      q2: "What's included after launch or handover?",
      a2: 'Web projects ship with 30 days of post-launch support for bugfixes related to the original scope — completely free. For 3D, branding and logo work you get all source files plus one tweak round within 14 days of delivery. After those windows, edits are billed per hour or rolled into a small retainer (from €95/month for web maintenance).',
      q3: 'Do you offer revisions?',
      a3: 'Yes — every package has a fixed number of revision rounds baked in (1–3 depending on tier and discipline). Extra rounds or out-of-scope changes are charged at my hourly rate with a clear estimate up front. No silent scope creep on the invoice.',
      q4: 'What does a project actually cost?',
      a4: 'Indicative starting points (excl. 21% VAT): Starter website from €1.800, full custom 3D site from €7.500, Logo only from €450, Mini branding from €1.500, motion & 3D (under Motion design) from €1.800. Each quote is tailored to your scope after a short discovery call so you only pay for what you actually need.',
      q5: 'Can I get branding or a logo without a website?',
      a5: 'Absolutely. Branding and logo design are standalone offers — they are not bundled into a web build by default. Plenty of clients come in with an existing site (or none at all) and just need a sharper identity, a proper guideline or a single mark. Same goes for 3D one-offs: hero render today, no website attached.',
      q6: 'Can you handle motion or 3D under a tight deadline?',
      a6: 'Motion and 3D both live under Motion design. A static hero render in 4K is realistic in about a week if the brief is clear. Animation loops and longer hero scenes really want 3+ weeks of breathing room — light, materials and timing all need iteration. Genuinely tight deadlines (under 5 working days for renders, under 2 weeks for animation) carry a +50% rush surcharge so I can prioritise your project over everything else.',
      q7: 'Can I calculate an estimated timeline and scope myself?',
      a7Before: 'Yes! You can use our interactive',
      a7Link: 'Project Scope & Timeline Estimator',
      a7After: 'on the Terms & Policies page to select your needed capabilities (Branding, Web, Motion, 3D) and get an instant delivery estimate before reaching out.',
      q8: 'Where are you based and how do we work?',
      a8: "I'm based in Belgium and work remotely with clients across Europe. Calls happen in Dutch or English, mostly via Google Meet. Once we kick off, you get a shared project board, weekly check-ins and a single contact point — me — from brief to delivery.",
    },
    cookies: {
      title: 'Cookies on this site',
      body: 'I use Google Analytics to count visits anonymously and learn which work resonates. No personal data, no ads. You can change your choice in Preferences.',
      accept: 'Accept all',
      reject: 'Reject all',
      preferences: 'Preferences',
      prefsTitle: 'Cookie preferences',
      prefsBody: "Pick what you're comfortable with. Strictly necessary cookies are always on — they're needed to keep the site running.",
      necessary: 'Strictly necessary',
      necessaryBody: 'Page rendering, security, and your cookie choice itself.',
      analytics: 'Analytics (Google Analytics 4)',
      analyticsBody: 'Anonymous, aggregated visit counts. Helps me see which projects are interesting.',
      save: 'Save preferences',
      back: 'Back',
    },
    worksPage: {
      metaTitle: 'Work',
      metaDescription: 'Selected works by SK Design — branding, design, motion and 3D projects.',
      heading: 'WORK',
      intro:
        'A cross-section of client work and personal experiments — branding, motion, 3D and video. Filter by discipline or search by technology to dig into the cases.',
      search: 'Search works by keyword...',
      clear: 'Clear',
      sort: 'Sort',
      recent: 'Recent',
      random: 'Random',
      sortOptions: 'Sort options',
      featured: 'Skills / Highlights',
      mostRecent: 'Most Recent',
      shuffle: 'Shuffle',
      filterYear: 'Filter Year:',
      all: 'All',
      project: 'project',
      projects: 'projects',
      reset: 'Reset filters',
      loadMore: 'Load More',
      noResultsTitle: 'No projects match these filters',
      noResultsBody:
        'Try a different discipline or year, or clear the search to see the full archive again.',
    },
    aboutPage: {
      metaTitle: 'About',
      metaDescription:
        'SK Design — Sander Kuyken. Brand, web, motion and 3D. Tools, process and the studio behind the work.',
      experienceIntro:
        'From agency work in motion and branding to my own freelance practice, I balance creative vision with hands-on execution—shipping work that feels intentional, energetic, and impeccably crafted.',
      educationIntro: 'A snapshot of the programs and schools that shaped my craft and process.',
      estLine1: 'Est',
      estLine2: '2004',
      heroAlt: 'Sander Kuyken, freelance creative designer',
      // The three highlighted words below must appear verbatim in `intro` —
      // about-page.css colours them through the keyword map in AboutPage.js.
      intro:
        "I'm Sander Kuyken, a graphic designer, UI/UX designer, and 3D/VFX explorer who designs with rhythm and insists every detail earns its place. Curiosity, caffeine, and the urge to ship bold ideas keep me iterating until it clicks.",
      experienceLine1: 'EXPE',
      experienceLine2: 'RIENCE',
      educationHeading: 'EDUCATION',
      roles: {
        cartel: 'Graphic Designer / Motion Graphics Designer',
        topssign: 'Graphic Designer',
        centerParks: 'Dishwasher',
      },
      degrees: {
        artist3d: '3D Artist',
        digitalBranding: 'Digital Branding',
        secondaryMultimedia: 'Secondary School – Multimedia',
      },
      skillsHeading: 'My Skills',
      skillsBody:
        "I love building thoughtful, performance-minded work that feels bold yet usable. From motion to micro-copy, it's the little details that make a product feel alive.",
      dragTools: 'Drag the tools around ↓',
      studioEyebrow: 'Studio',
      studioHeading: 'Based in Bilzen-Hoeselt',
      studioRemote:
        'Remote-friendly for most branding, motion and web projects across Belgium and beyond.',
    },
    // Tags stay English in data/*.js because they are filter identities; only
    // these display labels are translated.
    tags: {
      All: 'All',
      Design: 'Design',
      Motion: 'Motion',
      Branding: 'Branding',
      '3D': '3D',
      'Web / UX': 'Web / UX',
      '3D / VFX': '3D / VFX',
      Process: 'Process',
      Business: 'Business',
      AI: 'AI',
      Video: 'Video',
    },
    insightsPage: {
      metaTitle: 'Insights',
      metaDescription:
        'Notes on branding, motion design, web/UX and AI from Sander Kuyken — practical thinking on how design decisions help small businesses and products look and perform better.',
      heading: 'Insights',
      intro:
        'Short, practical notes on branding, motion, web/UX and AI — the thinking behind the work, written for people running real businesses and products.',
      article: 'article',
      articles: 'articles',
      toolsLink: 'Tools I use',
      filterLabel: 'Filter articles by category',
      searchLabel: 'Search insights',
      searchPlaceholder: 'Search insights...',
      clear: 'Clear',
      noResultsQuery: 'No articles found matching “{query}”.',
      noResults: 'No articles match the selected filter.',
      resetFilters: 'Reset search & filters',
      coverAlt: '{title} — cover',
    },
    insightPage: {
      notFoundMetaTitle: 'Insight not found',
      notFoundMetaDescription: 'This article could not be found.',
      notFoundHeading: 'Not found',
      notFoundBody: 'The article you are looking for does not exist or may have been moved.',
      backToInsights: 'Back to insights',
      breadcrumb: 'Insights',
      bookmark: 'Bookmark',
      bookmarked: 'Bookmarked ✓',
      bookmarkSaved: 'Article saved to bookmarks! ✓',
      bookmarkRemoved: 'Article removed from bookmarks',
      share: 'Share',
      shareCopied: 'Article link copied to clipboard!',
      shareFailed: 'Could not copy link',
      toc: 'In this article',
      pros: 'Pros',
      cons: 'Cons',
      copyPrompt: 'Copy Prompt',
      promptCopied: 'Prompt copied to clipboard!',
      promptFailed: 'Could not copy prompt',
      whatToCheck: 'What to check: ',
      illustrationAlt: 'Article illustration',
      visitSite: 'Visit site',
      visitNamed: 'Visit {name}',
      affiliateNote:
        'Some links in this article may be affiliate or referral links. If you sign up through them, I may earn a commission at no extra cost to you. Recommendations stay the same either way.',
      feedbackHeading: 'Was this insight helpful?',
      feedbackPrompt: 'Let us know what you think!',
      feedbackThanks: 'Thanks for voting!',
      feedbackYes: '👍 Yes, helpful',
      feedbackLearned: '💡 Learned something',
      feedbackToastYes: 'Thank you for your feedback! 👍',
      feedbackToastLearned: 'Thanks for reading! We appreciate it. 💡',
      related: 'Related articles',
      allInsights: 'All insights',
      progressLabel: 'Reading progress',
    },
    toolsPage: {
      metaTitle: 'Tools I use',
      metaDescription:
        'Design, web, 3D and AI tools I use and recommend — inspiration libraries, Figma, Webflow, Blender, ZBrush and more. Some links may be affiliate partnerships.',
      eyebrow: 'Resources',
      heading: 'TOOLS I USE',
      intro:
        'A living list of design, web, 3D and AI tools I reach for on client work. Links open in a new tab. Not listed in the main navigation — shared from Insights.',
      disclosure:
        'Disclosure: some links on this page are affiliate partnerships. If you buy through them, I may earn a commission at no extra cost to you.',
      visit: 'Visit →',
      preferWriting: 'Prefer the writing?',
      backToInsights: 'Back to Insights',
      categories: {
        Inspiration: 'Inspiration',
        Design: 'Design',
        Web: 'Web',
        '3D': '3D',
        Motion: 'Motion',
        'AI & Dev': 'AI & Dev',
        Partners: 'Partners',
        Other: 'Other',
      },
      blurbs: {
        mobbin: 'Mobile & web UI patterns from real products.',
        dribbble: 'Design community and shot inspiration.',
        behance: 'Case studies and creative portfolios.',
        awwwards: 'Award-winning web design references.',
        pinterest: 'Moodboards and visual research.',
        figma: 'UI design, prototyping and collaboration.',
        adobe: 'Photoshop, Illustrator, After Effects and more.',
        webflow: 'Visual web design and CMS publishing.',
        elementor: 'WordPress page builder for marketing sites.',
        wordpress: 'Open-source CMS powering countless sites.',
        blender: 'Open-source 3D modelling, animation and VFX.',
        zbrush: 'Digital sculpting for characters and hard-surface.',
        cursor: 'AI-assisted code editor for shipping faster.',
        githubCopilot: 'AI pair programmer in your editor.',
        windsurf: 'Agentic coding environment.',
        midjourney: 'Image generation for moodboards and concepts.',
        runway: 'AI video generation and editing tools.',
        kling: 'AI video generation for motion experiments.',
        luma: 'Dream Machine video and 3D capture tools.',
        capcut: 'Fast social video editing and templates.',
        claude: 'State-of-the-art reasoning, code and nuanced writing by Anthropic.',
        chatgpt: 'OpenAI conversational AI, Canvas, and reasoning models.',
        gemini: 'Google multimodal AI with 2M token context window.',
        cjaffiliate: 'Affiliate network placeholder for future partner links.',
      },
    },
    authorNote: {
      photoAlt: 'Sander Kuyken',
      writtenBy: 'Written by',
      bio:
        'Freelance creative designer focused on branding, motion, web/UX and 3D for small businesses and products. I write these notes the same way I work — practical, opinionated, and aimed at decisions that actually ship.',
      aboutMe: 'About me',
      tools: 'Tools I use',
      getInTouch: 'Get in touch',
    },
    projectPage: {
      notFoundMetaTitle: 'Project not found',
      notFoundMetaDescription: 'This project could not be found.',
      notFoundHeading: 'Not found',
      notFoundBody: 'The project you are looking for does not exist or may have been moved.',
      backToWorks: 'Back to work',
      sector: 'SECTOR',
      whatIDid: 'WHAT I DID',
      technologies: 'TECHNOLOGIES',
      deliverables: 'DELIVERABLES',
      roleExecution: 'ROLE & EXECUTION',
      defaultRole: 'Agile Sprint',
      visitSite: 'Visit Site',
      readTimeSuffix: 'min. read',
      enlargeImage: 'Enlarge image',
      playFullscreen: 'Play video fullscreen',
      relatedAria: 'Related thinking and capability',
      related: 'Related',
      relatedThinking: 'Related thinking',
      relevantCapability: 'Relevant capability',
      ctaTitle: 'Your project could be next',
      ctaBody: "Like what you see? Let's talk about what your brand needs.",
      ctaButton: 'Start a project',
      next: 'NEXT',
      clientReviewTitle: 'CLIENT\nREVIEW',
      watchVideoTitle: 'WATCH\nTHE VIDEO',
      modelTitle: '3D MODEL',
      flipTitle: 'FLIP\nTHROUGH',
      dragToRotate: 'Drag to rotate',
      pinchToZoom: 'Drag to rotate · pinch to zoom',
      projectFallback: 'Project',
      bannerAlt: '{project} — banner',
      detailAlt: '{project} — detail {n}',
      videoAlt: '{project} — project video',
      // Keyed by a slug of the English heading authored in data/projects.js.
      sectionTitles: {
        'client-review': 'CLIENT\nREVIEW',
        'watch-the-video': 'WATCH\nTHE VIDEO',
        'watch-the-video-s': "WATCH\nTHE VIDEO'S",
        '3d-model': '3D MODEL',
        'flip-through': 'FLIP\nTHROUGH',
        brandbook: 'Brandbook',
        'brandbook-personal-logo': 'Brandbook personal logo',
        'visit-the-live-site': 'Visit the live site',
        'look-at-the-website-urself': 'Look at the website yourself',
        'why-i-chose-this-logo': 'WHY I CHOSE THIS LOGO',
      },
      sectionBodies: {
        'why-i-chose-this-logo':
          'I chose this logo because it is simple and modern: easy to remember, easy to use, and it holds up in print as well as on the web.',
      },
      brandbook: {
        cover: 'Booklet cover',
        pageAlt: 'Booklet page {n}',
        previous: 'Previous page',
        next: 'Next page',
        hint: 'drag or click to flip',
      },
    },
    caseStory: {
      aria: 'Case story',
      challenge: 'The challenge',
      approach: 'The approach',
      result: 'The result',
      ctaBody: "Need a tailored solution for your brand? Let's scope it out together.",
      ctaLink: 'Inquire about {tag}',
      thisCapability: 'this capability',
    },
    gallery: {
      snapshotAlt: 'Project snapshot {n}',
      dragOrScroll: 'Drag or Scroll',
      previous: 'Previous snapshot',
      next: 'Next snapshot',
      interfaceStudy: 'Interface Study',
      moodboard: 'Moodboard',
      lightbox: 'Image Lightbox',
      closePreview: 'Close preview',
      enlargedAlt: 'Enlarged project image',
      closeEnlarged: 'Close enlarged view',
      enlargeImage: 'Enlarge project image {n}',
      enlargeVideo: 'Enlarge project video {n}',
      previousImage: 'Previous image',
      nextImage: 'Next image',
      fullSizeAlt: 'Full size snapshot',
    },
    testimonials: {
      line1: 'TESTI',
      line2: 'MONIALS',
      showAria: 'Show testimonial {n} of {total}',
      quotes: {
        1: {
          quote:
            "Sander turned a loose brief into a polished motion campaign that actually felt like us. He moved fast, communicated clearly, and sweated details we didn't even think to ask about.",
          author: 'Internship & motion team',
        },
        2: {
          quote:
            'The animations made complex pharmacy information genuinely easy to follow. Clean iconography, calm pacing, and exports ready for every platform — exactly what we needed.',
          author: 'Communications team',
        },
        3: {
          quote:
            'Working with Sander on the campaign identity was effortless. He gets brand consistency, keeps the energy high across every asset, and delivers work that feels far beyond his years.',
          author: 'Campaign team',
        },
      },
    },
    calculator: {
      eyebrow: 'Interactive Project Calculators',
      eyebrowAdmin: 'Admin · Calculator Studio',
      scopeTitle: 'Project Scope & Timeline',
      scopeIntro:
        'Select your required capabilities and project tier to compute an estimated delivery timeline before reaching out.',
      restartTitle: 'Restart Fee & Delay Policy',
      restartTitleAdmin: 'Project Pause & Cancel Calc',
      restartIntro:
        'A transparent estimate of how the deposit / midpoint / final structure plays out if the project gets paused or cancelled.',
      restartIntroAdmin: 'Internal cost-of-stop tool. Wires straight to the ToS clauses on /terms.',
      tabScope: 'Scope Estimator',
      tabRestart: 'Restart Fee',
      copyMarkdown: 'Copy MD',
      copied: 'Copied ✓',
      step1: '1. Select Required Capabilities',
      step2: '2. Select Project Scale',
      mostPopular: 'Most Popular',
      estimatedTimeline: 'Estimated Delivery Timeline',
      week: 'Week',
      weeks: 'Weeks',
      capabilitiesCount: '({count} capabilities · {tier})',
      bookScope: 'Book This Scope',
      services: {
        branding: {
          title: 'Brand Identity',
          desc: 'Logo system, brand book, typography, color palette & visual guidelines',
        },
        web: {
          title: 'Web Design & Build',
          desc: 'Responsive UX/UI, GSAP/Lenis animations, React/Webflow & SEO setup',
        },
        motion: {
          title: 'Motion Design',
          desc: 'Logo stings, social media motion templates, UI micro-interactions',
        },
        '3d': {
          title: '3D & VFX Renders',
          desc: 'Product visualization, 3D WebGL assets, Blender/VFX clips',
        },
      },
      scopeTiers: {
        essential: { name: 'Launchpad', desc: 'Focused MVP, quick turnaround, essential assets' },
        growth: {
          name: 'Studio Core',
          desc: 'Full-featured identity + web design, bespoke animations & guidelines',
        },
        flagship: {
          name: 'Flagship / Custom',
          desc: 'High-end 3D interactive, WebGL, custom motion system & deep design system',
        },
      },
      contractTotal: 'Contract total',
      exclVat: 'Excl. 21% VAT',
      contractHint: 'Use the figure from the signed quote.',
      projectStage: 'Project stage',
      whatHappened: 'What happened?',
      delayLength: 'Delay length',
      delayUnit: 'weeks',
      delayHint: '≥ 2 weeks triggers the 10% restart fee.',
      workCompleted: 'Work completed ({pct}%)',
      workCompletedHint: '{pct}% of the final 30% balance is billed.',
      scopeChangeNote:
        'Scope changes do not use the restart-fee schedule. Extra scope is quoted as a separate change-order per the',
      revisionsClause: 'Revisions clause',
      extraRevisions: 'Extra revisions',
      extraRevisionsUnit: 'rounds',
      extraRevisionsHint: '€{rate} / round beyond included.',
      outOfWindow: 'Out-of-window support',
      outOfWindowUnit: 'hours',
      outOfWindowHint: '€{rate} / hr outside 30/60d window.',
      breakdown: 'Estimated Settlement Breakdown',
      clause: 'Clause: {ref}',
      totalFee: 'Restart Fee / Additional Invoiced',
      totalRefund: 'Refund Due to Client',
      totalRetained: 'Total Retained from Payments',
      totalBalance: 'Settlement Balance',
      stages: {
        discovery: 'Discovery / pre-deposit',
        preMid: 'Pre-midpoint',
        postMid: 'Post-midpoint',
      },
      stageHints: {
        discovery: 'Briefing happened, no deposit paid yet.',
        preMid: 'Deposit (30%) paid, midpoint review not yet reached.',
        postMid: 'Midpoint (40%) paid, before final delivery.',
      },
      events: {
        delay: 'Delay (≥ 2 weeks)',
        cancel: 'Cancellation',
        scopeChange: 'Scope change',
      },
      eventHints: {
        delay: 'Project paused on the client side.',
        cancel: 'Project terminated by the client.',
        scopeChange: 'Out-of-brief work — quoted separately.',
      },
      line: {
        delayFee: 'Restart fee — {weeks} {unit} client-side delay (10% of contract)',
        delayBelowThreshold: 'Delay below 2-week threshold — no restart fee',
        cancelPreKickoff: 'Cancelled before kick-off — discovery time billed at hourly rate',
        depositRetained: 'Deposit retained (30%, non-refundable)',
        midpointPartial: 'Midpoint partially retained (50% of 40% — production at {pct}%)',
        midpointRefund: 'Midpoint refundable to client (50% of 40%)',
        midpointFull: 'Midpoint fully retained (production at {pct}% — past 50% threshold)',
        handover:
          'Deliverables handed over in current state against full payment of all invoiced amounts to date',
        scopeChange:
          'Scope change quoted separately as a change-order — not part of the restart-fee schedule',
        extraRevisions: 'Extra revision rounds × {count} (@ €{rate}/round)',
        outOfWindow: 'Out-of-support-window time × {hours}h (@ €{rate}/h)',
        week: 'week',
        weeks: 'weeks',
      },
      sum: {
        invoice: 'Invoice client: €{amount}',
        refund: 'Refund to client: €{amount}',
        retained: 'Retained: €{amount}',
        none: 'No fees apply — project continues without restart cost.',
      },
    },
    notFound: {
      metaTitle: 'Page not found',
      metaDescription: 'This page could not be found.',
      heading: '404',
      title: 'Page not found',
      body: "This page doesn't exist, or it moved. Here are a few places worth trying instead.",
      home: 'Back to home',
      works: 'View work',
      contact: 'Get in touch',
    },
    notice: {
      englishOnly: 'This page is only available in English for now.',
      englishOnlyArticle: 'This article is only available in English for now.',
    },
    common: {
      home: 'HOME',
      work: 'work',
      services: 'services',
      aboutMe: 'about me',
      insights: 'insights',
      contact: 'contact',
      language: 'Language',
      skipToContent: 'Skip to content',
      goToContact: 'Go to contact',
      localTime: 'LOCAL',
      close: 'Close',
      loading: 'Loading…',
      errorTitle: 'Something went wrong',
      errorBody: 'This section failed to load. Reloading the page usually fixes it.',
      reload: 'Reload the page',
      portraitAlt: 'Sander Kuyken, freelance creative designer based in Bilzen-Hoeselt, Belgium',
      videoPlayer: 'Video player',
      videoThumbnail: 'Video thumbnail',
    },
  },
  nl: {
    nav: {
      home: 'Home',
      about: 'Over',
      works: 'Werk',
      services: 'Diensten',
      insights: 'Insights',
      contact: 'Contact',
      toggle: 'Menu openen',
    },
    hero: {
      body: 'SK Design maakt merken, websites, motion en 3D voor bedrijven die opvallen. Een studio die je inhuurt — met pakketten, een proces, en een gesprek om te starten.',
      viewWork: 'Bekijk werk',
      bookCall: 'Plan een call',
      roleFreelance: 'Freelance',
      roleCreative: 'Creative',
      roleDesigner: 'Designer',
      disciplines: 'Brand · Web · Motion · 3D',
      openForProjects: 'Beschikbaar voor projecten',
      linkedinAria: 'LinkedIn-profiel van Sander Kuyken',
      artstationAria: 'ArtStation-profiel van Sander Kuyken',
      mascotAlt: 'Cartoonillustratie van een vrolijk limonadeglas-figuurtje',
    },
    home: {
      metaTitle: 'SK Design — Brand · Web · Motion · 3D',
      metaDescription:
        'SK Design — huisstijl, websites, motion en 3D voor bedrijven. Belgische studio. Pakketten, een vaste offerte, en een project dat je kunt starten.',
      selected: 'SELECTED',
      works: 'WERK',
      selectedBody:
        'Recente launches en eigen experimenten: een jonge studio die grote ideeën landt, snel schakelt en elk detail afwerkt.',
      latestWork: 'LAATSTE WERK',
      viewAll: 'Al het werk',
      archiveBlurb: 'Dit is alleen het laatste. Het volledige archief dekt design, motion, 3D en branding.',
      viewThisWork: 'Bekijk dit werk',
      aboutEyebrow: 'Een Belgische studio voor brand, web, motion en 3D — creatieve richting met technisch vakwerk.',
      aboutLine1: 'OVER',
      aboutLine2: 'MIJ',
      aboutHeading: 'Elke brief is een kans om te laten zien wat een next-gen studio kan.',
      aboutBody:
        'Ik ben Sander — branding, motion, 3D/VFX en web/UX. Het hele verhaal — hoe ik werk, opleiding en tools — staat op de about-pagina.',
      moreAbout: 'Meer over mij',
      servicesHeading: 'DIENSTEN',
      servicesBody:
        'Strategie, UI, motion en brandsystemen voor ambitieuze producten — met duidelijke pakketten en een vast plan voor we starten.',
      seeBreakdown: 'Volledige uitsplitsing & prijzen',
      discussThis: 'Bespreek dit',
      showPrice: 'Toon startprijs',
      hidePrice: 'Verberg prijs',
      processEyebrow: 'Hoe we werken',
      processTitle: 'Het proces',
      processIntro:
        'Een rustig, transparant pad van eerste call tot launch. Dezelfde ruggengraat voor een logo, een brandsysteem, motion of een volledige site.',
      process1Title: 'Ontdekken',
      process1Body:
        'Een korte discovery-call om doelen, scope en budget te mappen. Ik vertrek met een heldere brief, jij met een vast plan — geen vage beloftes.',
      process2Title: 'Design & build',
      process2Body:
        'Richting in Figma, daarna de build. Wireframes, look-dev en motion groeien samen, zodat je het werk ziet ontstaan — niet alleen slides.',
      process3Title: 'Fijnslijpen',
      process3Body:
        'Gestructureerde revisierondes waarin we details afwerken — spatiëring, timing, copy en performance — tot elk frame bewust voelt.',
      process4Title: 'Launch',
      process4Body:
        'Netjes opleveren: exports, handover, on-page SEO en support na launch, zodat het werk blijft presteren.',
      testimonialsBody:
        'Klanten praten over een partner met scherpe ideeën, transparante samenwerking, en werk dat overlevert zonder het trage agency-handboek.',
      ready: 'klaar om te starten?',
      footerCta: 'Heb je een idee? Laten we connecten en iets bijzonders maken.',
      cookiePrefs: 'Cookievoorkeuren',
      terms: 'Voorwaarden',
      viewProject: 'Bekijk het project',
    },
    servicesPage: {
      metaTitle: 'Diensten & prijzen',
      metaDescription:
        'Webdesign, motion design, branding en logo design — pakketten met transparante prijzen. Belgische studio voor brand, web, motion en 3D.',
      heading: 'DIENSTEN',
      intro: 'Een helder overzicht van elke dienst — wat er in elk pakket zit, wat het kost, en hoe lang het duurt.',
      vat: 'Alle prijzen excl. 21% btw.',
      faqJump: 'Vragen? Spring naar de FAQ',
      requestQuote: 'Vraag een offerte',
      seePackages: 'Bekijk pakketten',
      bestIf: 'Best als',
      process: 'Proces',
      addons: 'Beschikbare add-ons',
      mixMatch: 'Mix & match per pakket',
      retainerEyebrow: 'Doorlopend partnership',
      retainerTitle: 'Een designer on call, niet alleen een eenmalig project?',
      retainerBody:
        'Een maandelijks retainer houdt je site, merk en content in beweging — updates, nieuwe pagina’s, social motion en tweaks, tegen een vast tarief.',
      discussRetainer: 'Bespreek een retainer',
      customQuote: 'Vraag een offerte op maat',
      dontSee: 'Staat jouw scope er niet bij?',
      customBody:
        'Groter, gekker, of ergens ertussenin — ik scope graag een voorstel op maat dat past bij je timing en budget.',
      laneHeading: 'Oplossingen die bij de brief passen — kies je lane',
      builtWith: 'Gebouwd met',
      serviceCount: 'Dienst {n} / {total}',
    },
    contactPage: {
      metaTitle: 'Contact',
      metaDescription: 'Heb je een idee of project? Neem contact op met SK Design om doelen, scope en volgende stappen te bespreken.',
      heading: 'CONTACT',
      intro:
        'We beginnen met een korte hello om je project te overlopen — doelen, scope, timing. Ik beantwoord alles over het proces, en we zetten de volgende stappen uit.',
      emailTab: 'Mail me terug',
      callTab: 'Plan een call',
      introLong:
        'We beginnen met een korte hello om je project te overlopen — doelen, scope, timing. Ik beantwoord alles over het proces, en we zetten de volgende stappen uit. Tot snel.',
      pickHow: 'Kies hoe ik je terugkoppel — een schriftelijk antwoord per mail, of een korte discovery-call. Verplicht voor je verstuurt.',
      emailReply: 'Ik antwoord per mail binnen 24 werkuren.',
      emailBody: 'Vul het formulier hierboven in — pakket, scope, deadline. Je krijgt een offerte op maat en de volgende stappen in je inbox.',
      noCall: 'Geen call nodig',
      preferCall: 'Liever even praten? Plan een call →',
      nextHeading: 'Wat er daarna gebeurt',
      next1Title: 'Antwoord',
      next1Body: 'Een persoonlijke mail terug binnen 24 werkuren.',
      next2Title: 'Scope',
      next2Body: 'We stemmen doelen, deliverables en timing af.',
      next3Title: 'Voorstel',
      next3Body: 'Een vaste, op-maat offerte — geen verrassingen.',
      next4Title: 'Kickoff',
      next4Body: 'Voorschot, gedeeld bord, en we beginnen te bouwen.',
      howBack: 'Hoe moet ik je terugkoppelen?',
      belgiumTz: 'België · CET/CEST',
      discoveryCall: '30 min discovery-call',
      pickSlot: 'Kies een slot dat past — de bevestiging landt meteen in je inbox.',
      pickPackage: 'Kies een pakket',
      packageSuffix: 'pakket',
      optional: '(optioneel)',
      optionalShort: 'optioneel',
      vatExcl: 'alle prijzen excl. 21% btw',
      selectedTap: 'Geselecteerd · tik om te verwijderen',
      skipPackage:
        'Nog niet zeker? Sla dit over — combineer pakketten van meerdere diensten of beschrijf je project in het bericht, en ik kom terug met een voorstel op maat.',
      wizard: 'Begeleide intake',
      stepOf: 'Stap {n} van 3',
      stepYou: '1. Jij',
      stepProject: '2. Project',
      stepSend: '3. Details & versturen',
      errFillValid: 'Vul eerst je voornaam, achternaam en een geldig e-mailadres in.',
      errFillContinue: 'Vul je voornaam, achternaam en e-mailadres in om verder te gaan.',
      errEmail: 'Vul een geldig e-mailadres in.',
      errPickScope: 'Kies minstens één dienst, pakket of budget zodat ik je offerte kan inschatten.',
      successTitle: 'Bericht ontvangen',
      successBodyBefore: 'Ik mail je binnen 24 werkuren met een',
      successQuote: 'definitieve, scoped offerte',
      successBodyAfter: 'op basis van je aanvraag. Een bevestiging met samenvatting is onderweg naar je inbox.',
      estimatorPrompt: 'Eerst een geschatte timing en scope berekenen?',
      estimatorCta: 'Scope Estimator',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      email: 'E-mail',
      company: 'Bedrijf / merk',
      firstNamePlaceholder: 'Jan',
      lastNamePlaceholder: 'Janssens',
      emailPlaceholder: 'e-mailadres',
      companyPlaceholder: 'Acme Studio',
      howFound: 'Hoe heb je me gevonden?',
      selectOption: 'Kies een optie…',
      continueScope: 'Verder naar project-scope',
      servicesScope: 'Diensten & scope',
      servicesHint: 'Selecteer de diensten die je nodig hebt. Je mag meerdere diensten of pakketten kiezen.',
      combineHint:
        'Diensten combineren? Kies hierboven één pakket per dienst, dan tel ik de prijzen hieronder op. Liever volledig op maat? Beschrijf het in de volgende stap.',
      addons: 'Add-ons',
      addonsHint: 'Optionele extras bovenop je pakket — ze sturen de offerte bij. Zet aan wat past.',
      addonsFor: '{name} add-ons',
      budget: 'Geschat budget',
      backDetails: 'Terug naar je gegevens',
      continueSend: 'Verder naar bericht & versturen',
      message: 'Bericht',
      messageHint: 'Vertel kort over je doelen, timing of specifieke details.',
      messagePlaceholder: 'Vertel me over je project...',
      selectedPackages: 'Geselecteerde pakketten',
      quoteSummary: 'Offerte-samenvatting',
      removePackage: '{name}-pakket verwijderen',
      roughTotal: 'Ruwe totaalschatting',
      plusOnQuote: '+ items op offerte',
      finalQuoteNote: 'Definitieve offerte volgt per mail binnen 24 werkuren · alle prijzen excl. 21% btw',
      termsAgreeBefore: 'Ik ga akkoord met de',
      termsLink: 'voorwaarden & support',
      termsAgreeAfter: '— over prijs, betaling, supportvenster, revisies, eigendom en annulering.',
      backScope: 'Terug naar project-scope',
      submit: 'Versturen',
      sending: 'Bezig...',
      needMessage: 'Voeg je bericht toe',
      needMode: 'Kies hoe ik je terugkoppel',
      needTerms: 'Aanvaard de voorwaarden om te versturen',
      sendError: 'Er ging iets mis bij het versturen. Probeer opnieuw of mail info@skdesign.be.',
      svcWeb: 'Webdesign',
      svcMotion: 'Motion design',
      svcBranding: 'Branding',
      svcLogo: 'Logo design',
      svcRetainer: 'Retainer',
      svcOther: 'Andere',
      refLinkedIn: 'LinkedIn',
      refArtStation: 'ArtStation',
      refInstagram: 'Instagram',
      refReferral: 'Via iemand',
      refSearch: 'Zoeken',
      refOther: 'Andere',
    },
    faq: {
      heading: 'SAMENWERKEN',
      intro:
        'Eerlijke antwoorden op de vragen die elke klant stelt voor we starten. Timing, prijs, support na oplevering — wat ik zelf ook zou willen weten.',
      still: 'Nog een vraag?',
      stillBody: 'Stuur me een lijn — ik antwoord meestal binnen een dag.',
      ask: 'Stel me iets',
      eyebrow: 'Vaak gevraagd',
      q1: 'Hoe lang duurt een project?',
      a1: 'Timing hangt af van de discipline. Webdesign: 1–2 weken voor een Starter, 3–5 voor een Standard, 6–10+ voor een Premium 3D-site. Motion design (inclusief 3D / VFX): 1–2 weken voor een logo-animatie, 3–5 voor een campagne, 6–10+ voor een volledige 3D-scène. Branding: 2–3 weken voor een Mini-set, tot 7–10+ voor een Comprehensive systeem. Logo design: 1 week voor Logo only, tot 3 voor een volledig logosysteem. Exacte data worden vastgelegd voor we starten.',
      q2: 'Wat is inbegrepen na launch of oplevering?',
      a2: 'Webprojecten krijgen 30 dagen support na launch voor bugfixes binnen de oorspronkelijke scope — gratis. Voor 3D, branding en logo krijg je alle bronbestanden plus één tweaksronde binnen 14 dagen na oplevering. Daarna worden edits per uur gefactureerd of in een klein retainer opgenomen (vanaf €95/maand voor webonderhoud).',
      q3: 'Zijn er revisies?',
      a3: 'Ja — elk pakket heeft een vast aantal revisierondes (1–3, afhankelijk van tier en discipline). Extra rondes of werk buiten scope gaan tegen uurtarief, met een duidelijke schatting vooraf. Geen stille scope creep op de factuur.',
      q4: 'Wat kost een project écht?',
      a4: 'Indicatieve startpunten (excl. 21% btw): Starter-website vanaf €1.800, volledige custom 3D-site vanaf €7.500, Logo only vanaf €450, Mini branding vanaf €1.500, motion & 3D (onder Motion design) vanaf €1.800. Elke offerte wordt op maat gemaakt na een korte discovery-call, zodat je alleen betaalt voor wat je nodig hebt.',
      q5: 'Kan ik branding of een logo zonder website?',
      a5: 'Absoluut. Branding en logo design zijn standalone — ze zitten niet standaard in een web-build. Veel klanten komen met een bestaande site (of geen) en willen een scherpere identiteit, een guideline of één merk. Hetzelfde voor 3D one-offs: hero-render vandaag, geen website eraan.',
      q6: 'Kun je motion of 3D onder een krappe deadline?',
      a6: 'Motion en 3D vallen onder Motion design. Een statische hero-render in 4K is realistisch in ongeveer een week als de brief helder is. Animatieloops en langere hero-scènes vragen écht 3+ weken ademruimte — licht, materialen en timing moeten itereren. Echt krappe deadlines (onder 5 werkdagen voor renders, onder 2 weken voor animatie) krijgen een +50% rush-toeslag zodat ik jouw project voorrang kan geven.',
      q7: 'Kan ik zelf een geschatte timing en scope berekenen?',
      a7Before: 'Ja! Je kunt onze interactieve',
      a7Link: 'Projectscope & timing-calculator',
      a7After: 'op de Terms & Policies-pagina gebruiken om de nodige disciplines (Branding, Web, Motion, 3D) te kiezen en meteen een leveringsschatting te krijgen voor je contact opneemt.',
      q8: 'Waar zit je en hoe werken we samen?',
      a8: 'Ik zit in België en werk remote met klanten in heel Europa. Calls in het Nederlands of Engels, meestal via Google Meet. Na de kick-off krijg je een gedeeld projectbord, wekelijkse check-ins en één contactpunt — ik — van brief tot oplevering.',
    },
    cookies: {
      title: 'Cookies op deze site',
      body: 'Ik gebruik Google Analytics om bezoeken anoniem te tellen en te zien welk werk aanslaat. Geen persoonsgegevens, geen ads. Je keuze wijzig je in Voorkeuren.',
      accept: 'Alles aanvaarden',
      reject: 'Alles weigeren',
      preferences: 'Voorkeuren',
      prefsTitle: 'Cookievoorkeuren',
      prefsBody: 'Kies wat oké voelt. Strikt noodzakelijke cookies staan altijd aan — die heeft de site nodig om te werken.',
      necessary: 'Strikt noodzakelijk',
      necessaryBody: 'Pagina’s tonen, beveiliging, en je cookiekeuze zelf.',
      analytics: 'Analytics (Google Analytics 4)',
      analyticsBody: 'Anonieme, gebundelde bezoekcijfers. Zo zie ik welke projecten interessant zijn.',
      save: 'Voorkeuren opslaan',
      back: 'Terug',
    },
    worksPage: {
      metaTitle: 'Werk',
      metaDescription: 'Geselecteerd werk van SK Design — branding, design, motion en 3D.',
      heading: 'WERK',
      intro:
        'Een dwarsdoorsnede van klantwerk en eigen experimenten — branding, motion, 3D en video. Filter op discipline of zoek op technologie.',
      search: 'Zoek werk op trefwoord...',
      clear: 'Wissen',
      sort: 'Sorteer',
      recent: 'Recent',
      random: 'Random',
      sortOptions: 'Sorteeropties',
      featured: 'Skills / highlights',
      mostRecent: 'Meest recent',
      shuffle: 'Shuffle',
      filterYear: 'Filter jaar:',
      all: 'Alles',
      project: 'project',
      projects: 'projecten',
      reset: 'Filters wissen',
      loadMore: 'Meer laden',
      noResultsTitle: 'Geen projecten met deze filters',
      noResultsBody:
        'Probeer een andere discipline of een ander jaar, of wis de zoekopdracht om het volledige archief weer te zien.',
    },
    aboutPage: {
      metaTitle: 'Over',
      metaDescription:
        'SK Design — Sander Kuyken. Brand, web, motion en 3D. Tools, proces en de studio achter het werk.',
      experienceIntro:
        'Van agency-werk in motion en branding tot mijn eigen freelance practice: creatieve visie met hands-on uitvoering — werk dat bewust, energiek en afgewerkt aanvoelt.',
      educationIntro: 'Een snapshot van de opleidingen die mijn craft en proces hebben gevormd.',
      estLine1: 'Sinds',
      estLine2: '2004',
      heroAlt: 'Sander Kuyken, freelance creatief designer',
      // De drie gemarkeerde woorden hieronder moeten letterlijk in `intro` staan —
      // about-page.css kleurt ze via de keyword-map in AboutPage.js.
      intro:
        'Ik ben Sander Kuyken, grafisch ontwerper, UI/UX-designer en 3D/VFX-verkenner die ontwerpt op ritme en erop staat dat elk detail zijn plek verdient. Nieuwsgierigheid, cafeïne en de drang om gedurfde ideeën te shippen houden me itereren tot het klikt.',
      experienceLine1: 'ERVA',
      experienceLine2: 'RING',
      educationHeading: 'OPLEIDING',
      roles: {
        cartel: 'Grafisch ontwerper / motion graphics designer',
        topssign: 'Grafisch ontwerper',
        centerParks: 'Afwasser',
      },
      degrees: {
        artist3d: '3D Artist',
        digitalBranding: 'Digital Branding',
        secondaryMultimedia: 'Secundair onderwijs – Multimedia',
      },
      skillsHeading: 'Mijn skills',
      skillsBody:
        'Ik bouw graag doordacht, performant werk dat gedurfd maar bruikbaar blijft. Van motion tot micro-copy: het zijn de kleine details die een product levend maken.',
      dragTools: 'Sleep de tools rond ↓',
      studioEyebrow: 'Studio',
      studioHeading: 'Gevestigd in Bilzen-Hoeselt',
      studioRemote:
        'Remote-friendly voor de meeste branding-, motion- en webprojecten in België en daarbuiten.',
    },
    tags: {
      All: 'Alles',
      Design: 'Design',
      Motion: 'Motion',
      Branding: 'Branding',
      '3D': '3D',
      'Web / UX': 'Web / UX',
      '3D / VFX': '3D / VFX',
      Process: 'Proces',
      Business: 'Business',
      AI: 'AI',
      Video: 'Video',
    },
    insightsPage: {
      metaTitle: 'Insights',
      metaDescription:
        'Notities over branding, motion design, web/UX en AI van Sander Kuyken — praktisch denkwerk over hoe designkeuzes kleine bedrijven en producten beter laten oogen en presteren.',
      heading: 'Insights',
      intro:
        'Korte, praktische notities over branding, motion, web/UX en AI — het denkwerk achter het werk, geschreven voor mensen met een echt bedrijf of product.',
      article: 'artikel',
      articles: 'artikels',
      toolsLink: 'Tools die ik gebruik',
      filterLabel: 'Filter artikels op categorie',
      searchLabel: 'Zoek in insights',
      searchPlaceholder: 'Zoek in insights...',
      clear: 'Wissen',
      noResultsQuery: 'Geen artikels gevonden voor “{query}”.',
      noResults: 'Geen artikels binnen de gekozen filter.',
      resetFilters: 'Zoekopdracht & filters wissen',
      coverAlt: '{title} — cover',
    },
    insightPage: {
      notFoundMetaTitle: 'Artikel niet gevonden',
      notFoundMetaDescription: 'Dit artikel kon niet gevonden worden.',
      notFoundHeading: 'Niet gevonden',
      notFoundBody: 'Het artikel dat je zoekt bestaat niet of is verplaatst.',
      backToInsights: 'Terug naar insights',
      breadcrumb: 'Insights',
      bookmark: 'Bewaren',
      bookmarked: 'Bewaard ✓',
      bookmarkSaved: 'Artikel bewaard! ✓',
      bookmarkRemoved: 'Artikel uit je bewaarde items gehaald',
      share: 'Delen',
      shareCopied: 'Link gekopieerd!',
      shareFailed: 'Kon de link niet kopiëren',
      toc: 'In dit artikel',
      pros: 'Voordelen',
      cons: 'Nadelen',
      copyPrompt: 'Prompt kopiëren',
      promptCopied: 'Prompt gekopieerd!',
      promptFailed: 'Kon de prompt niet kopiëren',
      whatToCheck: 'Waar je op let: ',
      illustrationAlt: 'Illustratie bij het artikel',
      visitSite: 'Bekijk site',
      visitNamed: 'Bekijk {name}',
      affiliateNote:
        'Sommige links in dit artikel zijn affiliate- of referrallinks. Als je je via zo’n link aanmeldt, krijg ik mogelijk een commissie — zonder extra kosten voor jou. Mijn aanbevelingen blijven dezelfde.',
      feedbackHeading: 'Was dit artikel nuttig?',
      feedbackPrompt: 'Laat weten wat je ervan vindt.',
      feedbackThanks: 'Bedankt voor je stem.',
      feedbackYes: '👍 Ja, nuttig',
      feedbackLearned: '💡 Iets bijgeleerd',
      feedbackToastYes: 'Bedankt voor je feedback! 👍',
      feedbackToastLearned: 'Bedankt voor het lezen. 💡',
      related: 'Gerelateerde artikels',
      allInsights: 'Alle insights',
      progressLabel: 'Leesvoortgang',
    },
    toolsPage: {
      metaTitle: 'Tools die ik gebruik',
      metaDescription:
        'Design-, web-, 3D- en AI-tools die ik gebruik en aanraad — inspiratiebibliotheken, Figma, Webflow, Blender, ZBrush en meer. Sommige links zijn affiliate-partnerships.',
      eyebrow: 'Resources',
      heading: 'MIJN TOOLS',
      intro:
        'Een levende lijst van design-, web-, 3D- en AI-tools waar ik in klantwerk naar grijp. Links openen in een nieuw tabblad. Niet in de hoofdnavigatie — gedeeld vanuit Insights.',
      disclosure:
        'Transparantie: sommige links op deze pagina zijn affiliate-partnerships. Koop je erdoor, dan krijg ik mogelijk een commissie — zonder extra kosten voor jou.',
      visit: 'Bekijk →',
      preferWriting: 'Liever lezen?',
      backToInsights: 'Terug naar Insights',
      categories: {
        Inspiration: 'Inspiratie',
        Design: 'Design',
        Web: 'Web',
        '3D': '3D',
        Motion: 'Motion',
        'AI & Dev': 'AI & dev',
        Partners: 'Partners',
        Other: 'Andere',
      },
      blurbs: {
        mobbin: 'UI-patronen voor mobile & web uit echte producten.',
        dribbble: 'Designcommunity en inspiratie per shot.',
        behance: 'Case studies en creatieve portfolio’s.',
        awwwards: 'Bekroonde webdesign-referenties.',
        pinterest: 'Moodboards en visueel onderzoek.',
        figma: 'UI-design, prototyping en samenwerken.',
        adobe: 'Photoshop, Illustrator, After Effects en meer.',
        webflow: 'Visueel webdesign en CMS-publicatie.',
        elementor: 'WordPress-pagebuilder voor marketingsites.',
        wordpress: 'Open-source CMS achter talloze sites.',
        blender: 'Open-source 3D-modelling, animatie en VFX.',
        zbrush: 'Digital sculpting voor characters en hard-surface.',
        cursor: 'AI-code-editor om sneller te shippen.',
        githubCopilot: 'AI-pair programmer in je editor.',
        windsurf: 'Agentische coding-omgeving.',
        midjourney: 'Beeldgeneratie voor moodboards en concepten.',
        runway: 'AI-videogeneratie en editing.',
        kling: 'AI-videogeneratie voor motion-experimenten.',
        luma: 'Dream Machine-video en 3D-capture.',
        capcut: 'Snelle social video-editing en templates.',
        claude: 'Sterk in reasoning, code en genuanceerd schrijven — van Anthropic.',
        chatgpt: 'Conversationele AI van OpenAI, met Canvas en reasoning-modellen.',
        gemini: 'Multimodale AI van Google met 2M token context.',
        cjaffiliate: 'Affiliate-netwerk, placeholder voor toekomstige partnerlinks.',
      },
    },
    authorNote: {
      photoAlt: 'Sander Kuyken',
      writtenBy: 'Geschreven door',
      bio:
        'Freelance creative designer met focus op branding, motion, web/UX en 3D voor kleine bedrijven en producten. Ik schrijf deze notities zoals ik werk — praktisch, met een mening, en gericht op keuzes die echt gemaakt worden.',
      aboutMe: 'Over mij',
      tools: 'Tools die ik gebruik',
      getInTouch: 'Neem contact op',
    },
    projectPage: {
      notFoundMetaTitle: 'Project niet gevonden',
      notFoundMetaDescription: 'Dit project kon niet gevonden worden.',
      notFoundHeading: 'Niet gevonden',
      notFoundBody: 'Het project dat je zoekt bestaat niet of is verplaatst.',
      backToWorks: 'Terug naar werk',
      sector: 'SECTOR',
      whatIDid: 'WAT IK DEED',
      technologies: 'TECHNOLOGIEËN',
      deliverables: 'DELIVERABLES',
      roleExecution: 'ROL & UITVOERING',
      defaultRole: 'Agile sprint',
      visitSite: 'Bekijk site',
      readTimeSuffix: 'min. leestijd',
      enlargeImage: 'Afbeelding vergroten',
      playFullscreen: 'Video schermvullend spelen',
      relatedAria: 'Gerelateerd denkwerk en dienst',
      related: 'Gerelateerd',
      relatedThinking: 'Gerelateerd denkwerk',
      relevantCapability: 'Relevante dienst',
      ctaTitle: 'Jouw project kan het volgende zijn',
      ctaBody: 'Bevalt wat je ziet? Laten we bespreken wat jouw merk nodig heeft.',
      ctaButton: 'Start een project',
      next: 'VOLGENDE',
      clientReviewTitle: 'REVIEW\nVAN DE KLANT',
      watchVideoTitle: 'BEKIJK\nDE VIDEO',
      modelTitle: '3D-MODEL',
      flipTitle: 'BLADER\nERDOOR',
      dragToRotate: 'Sleep om te draaien',
      pinchToZoom: 'Sleep om te draaien · knijp om te zoomen',
      projectFallback: 'Project',
      bannerAlt: '{project} — banner',
      detailAlt: '{project} — detail {n}',
      videoAlt: '{project} — projectvideo',
      sectionTitles: {
        'client-review': 'REVIEW\nVAN DE KLANT',
        'watch-the-video': 'BEKIJK\nDE VIDEO',
        'watch-the-video-s': "BEKIJK\nDE VIDEO'S",
        '3d-model': '3D-MODEL',
        'flip-through': 'BLADER\nERDOOR',
        brandbook: 'Brandbook',
        'brandbook-personal-logo': 'Brandbook persoonlijk logo',
        'visit-the-live-site': 'Bekijk de live site',
        'look-at-the-website-urself': 'Bekijk de website zelf',
        'why-i-chose-this-logo': 'WAAROM DIT LOGO',
      },
      sectionBodies: {
        'why-i-chose-this-logo':
          'Ik koos dit logo omdat het simpel en modern is: makkelijk te onthouden, makkelijk te gebruiken, en het werkt zowel in print als op het web.',
      },
      brandbook: {
        cover: 'Cover van het boekje',
        pageAlt: 'Pagina {n} van het boekje',
        previous: 'Vorige pagina',
        next: 'Volgende pagina',
        hint: 'sleep of klik om te bladeren',
      },
    },
    caseStory: {
      aria: 'Case story',
      challenge: 'De uitdaging',
      approach: 'De aanpak',
      result: 'Het resultaat',
      ctaBody: 'Nodig je merk een oplossing op maat? Laten we het samen scopen.',
      ctaLink: 'Vraag naar {tag}',
      thisCapability: 'deze dienst',
    },
    gallery: {
      snapshotAlt: 'Projectbeeld {n}',
      dragOrScroll: 'Sleep of scroll',
      previous: 'Vorig beeld',
      next: 'Volgend beeld',
      interfaceStudy: 'Interface-studie',
      moodboard: 'Moodboard',
      lightbox: 'Beeld-lightbox',
      closePreview: 'Voorbeeld sluiten',
      enlargedAlt: 'Vergroot projectbeeld',
      closeEnlarged: 'Vergrote weergave sluiten',
      enlargeImage: 'Projectbeeld {n} vergroten',
      enlargeVideo: 'Projectvideo {n} vergroten',
      previousImage: 'Vorige afbeelding',
      nextImage: 'Volgende afbeelding',
      fullSizeAlt: 'Beeld op volledige grootte',
    },
    testimonials: {
      line1: 'TESTI',
      line2: 'MONIALS',
      showAria: 'Toon testimonial {n} van {total}',
      quotes: {
        1: {
          quote:
            'Sander maakte van een losse brief een afgewerkte motion-campagne die echt als ons voelde. Hij schakelde snel, communiceerde helder, en werkte details af waar wij niet eens aan gedacht hadden.',
          author: 'Stage- & motionteam',
        },
        2: {
          quote:
            'De animaties maakten complexe apotheekinformatie echt makkelijk te volgen. Heldere iconografie, rustige pacing, en exports klaar voor elk platform — precies wat we nodig hadden.',
          author: 'Communicatieteam',
        },
        3: {
          quote:
            'Samenwerken met Sander aan de campagne-identiteit ging vanzelf. Hij snapt merkconsistentie, houdt de energie hoog over elk middel, en levert werk dat ver boven zijn jaren uitstijgt.',
          author: 'Campagneteam',
        },
      },
    },
    calculator: {
      eyebrow: 'Interactieve projectcalculators',
      eyebrowAdmin: 'Admin · Calculator Studio',
      scopeTitle: 'Projectscope & timing',
      scopeIntro:
        'Kies de disciplines die je nodig hebt en de projectschaal, en bereken een geschatte levertermijn voor je contact opneemt.',
      restartTitle: 'Restart fee & vertragingsbeleid',
      restartTitleAdmin: 'Pauze- & annuleringscalculator',
      restartIntro:
        'Een transparante schatting van hoe de structuur voorschot / midpoint / oplevering uitpakt als het project gepauzeerd of geannuleerd wordt.',
      restartIntroAdmin: 'Interne cost-of-stop-tool. Verwijst rechtstreeks naar de clausules op /terms.',
      tabScope: 'Scope Estimator',
      tabRestart: 'Restart fee',
      copyMarkdown: 'Kopieer MD',
      copied: 'Gekopieerd ✓',
      step1: '1. Kies de nodige disciplines',
      step2: '2. Kies de projectschaal',
      mostPopular: 'Meest gekozen',
      estimatedTimeline: 'Geschatte levertermijn',
      week: 'week',
      weeks: 'weken',
      capabilitiesCount: '({count} disciplines · {tier})',
      bookScope: 'Boek deze scope',
      services: {
        branding: {
          title: 'Merkidentiteit',
          desc: 'Logosysteem, brandbook, typografie, kleurenpalet & visuele richtlijnen',
        },
        web: {
          title: 'Webdesign & build',
          desc: 'Responsieve UX/UI, GSAP/Lenis-animaties, React/Webflow & SEO-setup',
        },
        motion: {
          title: 'Motion design',
          desc: 'Logo stings, social motion-templates, UI-micro-interacties',
        },
        '3d': {
          title: '3D- & VFX-renders',
          desc: 'Productvisualisatie, 3D WebGL-assets, Blender/VFX-clips',
        },
      },
      scopeTiers: {
        essential: { name: 'Launchpad', desc: 'Gefocuste MVP, snelle doorloop, essentiële assets' },
        growth: {
          name: 'Studio Core',
          desc: 'Volledige identiteit + webdesign, animaties op maat & richtlijnen',
        },
        flagship: {
          name: 'Flagship / Custom',
          desc: 'High-end interactieve 3D, WebGL, motion-systeem op maat & diep designsysteem',
        },
      },
      contractTotal: 'Contracttotaal',
      exclVat: 'Excl. 21% btw',
      contractHint: 'Gebruik het bedrag uit de ondertekende offerte.',
      projectStage: 'Projectfase',
      whatHappened: 'Wat is er gebeurd?',
      delayLength: 'Duur van de vertraging',
      delayUnit: 'weken',
      delayHint: 'Vanaf 2 weken geldt de restart fee van 10%.',
      workCompleted: 'Werk afgerond ({pct}%)',
      workCompletedHint: '{pct}% van het laatste saldo van 30% wordt gefactureerd.',
      scopeChangeNote:
        'Scope-wijzigingen vallen niet onder de restart fee. Extra scope wordt apart geoffreerd als change-order volgens de',
      revisionsClause: 'clausule revisies',
      extraRevisions: 'Extra revisies',
      extraRevisionsUnit: 'rondes',
      extraRevisionsHint: '€{rate} / ronde boven het inbegrepen aantal.',
      outOfWindow: 'Support buiten venster',
      outOfWindowUnit: 'uren',
      outOfWindowHint: '€{rate} / uur buiten het venster van 30/60 dagen.',
      breakdown: 'Geschatte afrekening',
      clause: 'Clausule: {ref}',
      totalFee: 'Restart fee / extra te factureren',
      totalRefund: 'Terug te betalen aan klant',
      totalRetained: 'Totaal ingehouden op betalingen',
      totalBalance: 'Saldo afrekening',
      stages: {
        discovery: 'Discovery / voor voorschot',
        preMid: 'Voor midpoint',
        postMid: 'Na midpoint',
      },
      stageHints: {
        discovery: 'Briefing gebeurd, nog geen voorschot betaald.',
        preMid: 'Voorschot (30%) betaald, midpoint-review nog niet bereikt.',
        postMid: 'Midpoint (40%) betaald, voor de finale oplevering.',
      },
      events: {
        delay: 'Vertraging (≥ 2 weken)',
        cancel: 'Annulering',
        scopeChange: 'Scope-wijziging',
      },
      eventHints: {
        delay: 'Project gepauzeerd aan klantzijde.',
        cancel: 'Project stopgezet door de klant.',
        scopeChange: 'Werk buiten de brief — apart geoffreerd.',
      },
      line: {
        delayFee: 'Restart fee — {weeks} {unit} vertraging aan klantzijde (10% van het contract)',
        delayBelowThreshold: 'Vertraging onder de drempel van 2 weken — geen restart fee',
        cancelPreKickoff: 'Geannuleerd voor de kick-off — discovery-tijd tegen uurtarief',
        depositRetained: 'Voorschot ingehouden (30%, niet terugbetaalbaar)',
        midpointPartial: 'Midpoint gedeeltelijk ingehouden (50% van 40% — productie op {pct}%)',
        midpointRefund: 'Midpoint terugbetaalbaar aan klant (50% van 40%)',
        midpointFull: 'Midpoint volledig ingehouden (productie op {pct}% — voorbij de drempel van 50%)',
        handover:
          'Deliverables worden opgeleverd in de huidige staat, tegen volledige betaling van alle tot nu toe gefactureerde bedragen',
        scopeChange:
          'Scope-wijziging wordt apart geoffreerd als change-order — valt niet onder de restart fee',
        extraRevisions: 'Extra revisierondes × {count} (@ €{rate}/ronde)',
        outOfWindow: 'Support buiten venster × {hours} u (@ €{rate}/u)',
        week: 'week',
        weeks: 'weken',
      },
      sum: {
        invoice: 'Factureren aan klant: €{amount}',
        refund: 'Terugbetalen aan klant: €{amount}',
        retained: 'Ingehouden: €{amount}',
        none: 'Geen kosten van toepassing — het project loopt door zonder restart-kost.',
      },
    },
    notFound: {
      metaTitle: 'Pagina niet gevonden',
      metaDescription: 'Deze pagina kon niet gevonden worden.',
      heading: '404',
      title: 'Pagina niet gevonden',
      body: 'Deze pagina bestaat niet, of ze is verhuisd. Dit zijn een paar plekken die wel werken.',
      home: 'Terug naar home',
      works: 'Bekijk werk',
      contact: 'Neem contact op',
    },
    notice: {
      englishOnly: 'Deze pagina is voorlopig alleen in het Engels beschikbaar.',
      englishOnlyArticle: 'Dit artikel is voorlopig alleen in het Engels beschikbaar.',
    },
    common: {
      home: 'HOME',
      work: 'werk',
      services: 'diensten',
      aboutMe: 'over mij',
      insights: 'insights',
      contact: 'contact',
      language: 'Taal',
      skipToContent: 'Naar de inhoud',
      goToContact: 'Naar contact',
      localTime: 'LOKAAL',
      close: 'Sluiten',
      loading: 'Laden…',
      errorTitle: 'Er ging iets mis',
      errorBody: 'Dit onderdeel kon niet laden. Meestal helpt de pagina herladen.',
      reload: 'Pagina herladen',
      portraitAlt: 'Sander Kuyken, freelance creative designer uit Bilzen-Hoeselt, België',
      videoPlayer: 'Videospeler',
      videoThumbnail: 'Videovoorbeeld',
    },
  },
};
